const TrustpilotStars = ({ starRating }) => (
  <span className="l-fl ie-fl1">
    <div className="rating-holder">
      <div className="c-rating fl ie-fl1" data-rating-value={starRating}>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}
        />
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}
        />
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}
        />
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}
        />
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}
        />
      </div>
    </div>
  </span>
);

export default TrustpilotStars;
